import { createSlice } from '@reduxjs/toolkit';

// `update` is a load from the server (preferences/get): it also sets `loaded`, a marker with its
// own sequence number, so a page can tell a load from a save's acknowledgement. `saved` is the
// user's own save, applied at once. `loadFailed` is a load that got no answer: it sets `loaded`
// with no currency, so a page waiting for the load goes on with the default. `loaded` is never
// sent to the server.
export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: {},
  reducers: {
    update: (state, action) => ({
      ...state,
      ...action.payload,
      loaded: {
        seq: ((state.loaded && state.loaded.seq) || 0) + 1,
        currency: (action.payload || {}).currency,
      },
    }),
    saved: (state, action) => ({ ...state, ...action.payload }),
    loadFailed: (state) => ({
      ...state,
      loaded: {
        seq: ((state.loaded && state.loaded.seq) || 0) + 1,
        currency: undefined,
        failed: true,
      },
    }),
  },
});

export default preferencesSlice.reducer;
